import React, { useEffect, useState } from "react";
import CardLayoutOne from "../../components/cards/CardLayoutOne";
import MainButton from "../../components/buttons/MainButton";
import { useNavigate } from "react-router-dom";
import Snackbar, { SnackbarType } from "../../components/snackbar/Snackbar";
import { codeStatusRequest } from "../../core/subscription/request";
import { t } from "i18next";

const url = new URL(window.location.href).searchParams.get("code");


const Basic = () => {
  const navigate = useNavigate();


const products = [
  {
    id: 30,
    name: `${t("twintreeplus.head")}`,
    description:
     `${t("twintreeplus.description")}`,
    price: "33",
    image:
      "https://gardenof.life/storage/images/bali/938CMyMhk4nLZrhe9XEoZGGym.png",
    link: "/subscription/purchase",
    is_subscribed: true,
    quantity: 1,
  },
  {
    id: 8,
    name: `${t("endarged.head")} 1x`,
    description:
      `${t("endarged.description")}`,
    price: "33",
    image:
      "https://gardenof.life/storage/images/botswana/na48cTEFroTcLryo3wiBmicVC.png",
    link: "/subscription/purchase",
    is_subscribed: true,
    quantity: 1,
  },
  {
    id: 2,
    name: `${t("treeoflife.head")} 2x`,
    description:
     `${t("treeoflife.description")}`,
    price: "44",
    image:
      "https://gardenof.life/storage/images/bali/938CMyMhk4nLZrhe9XEoZGGym.png",
    link: "/subscription/purchase",
    is_subscribed: true,
    quantity: 2,
  },
];
  const [selectedProductId, setSelectedProductId] = useState<number | null>(
    () => {
      const savedId = localStorage.getItem("selectedProductId");
      return savedId ? parseInt(savedId, 10) : null;
    }
  );
  
  const handleSelect = (id: number, isChecked: boolean) => {
    if (isChecked) {
      setSelectedProductId(id);
      localStorage.setItem("selectedProductId", id.toString());
    } else {
      setSelectedProductId(null);
      localStorage.removeItem("selectedProductId");
    }
  };
  const subscriptionLinkCode =
    new URL(window.location.href).searchParams.get("code") || "defaultCode";

  const handleClick = () => {
    if (selectedProductId) {
      const selectedProduct = products.find(
        (product) => product.id === selectedProductId
      );

      localStorage.setItem("selectedProduct", JSON.stringify(selectedProduct));
      localStorage.setItem("subscriptionLinkCode", subscriptionLinkCode);
      navigate("/checkout");
    }
  };



  const [snackbarState, setSnackbarState] = useState<{
    show: boolean;
    message: string;
    type: SnackbarType;
  }>({
    show: false,
    message: "",
    type: "error", // Default type
  });

  const [isBuyButtonDisabled, setIsBuyButtonDisabled] = useState(false);

  // Function to show the snackbar
  const showSnackbar = (message: string, type: SnackbarType) => {
    setSnackbarState({ show: true, message, type });
  };

  // Function to hide the snackbar
  const hideSnackbar = () => {
    setSnackbarState((prevState) => ({ ...prevState, show: false }));
  };

  const codeStatus = async () => {
    const subscriptionLinkCode =
      new URL(window.location.href).searchParams.get("code") || "defaultCode";

    try {
      const paymentData = {
        // subscription: true,
        subscription_link_code: subscriptionLinkCode,
      };

      const response = await codeStatusRequest(paymentData);
      if (response.data.status == "error") {
        setIsBuyButtonDisabled(true);
        showSnackbar(
          "This product purchase link against Subscription is already Consumed",
          "error"
        );
      } else {
        setIsBuyButtonDisabled(false);
      }
    } catch (error) {
      console.error("Wrong Code:", error);
    }
  };
  useEffect(() => {
    codeStatus();
  }, []);

  window.addEventListener("unload", (event) => {
    codeStatus();
    console.log("API call after page reload");
  });

  return (
    <>
      <section className="pb-5 subscription-sec">
        <div className="container">
          <div className="subscription-head-sec text-center">
            <h1 className="mb-3">{t("basic.heading")} {t("plan")}</h1>
            <h6 className="mb-3">{t("product.subhead")}</h6>
          </div>
          <div className="row mt-5">
            {products.map((item, index) => (
              <CardLayoutOne
                key={index}
                btnText={t("buttons.buyNow")}
                btnFullWidth={""}
                colClass={"col-lg-4 col-md-6"}
                shadow={true}
                title={item.name}
                bgColor={"three"}
                image={item.image}
                titleClass={"f-title-bold"}
                imageClass={"h-200"}
                price={item.price}
                description={item.description}
                is_subscribed={item.is_subscribed}
                id={item.id}
                disabled={
                  selectedProductId !== null && selectedProductId !== item.id
                }
                onSelect={handleSelect}
                isChecked={selectedProductId === item.id}
              />
            ))}
          </div>

          <div className="text-center">
            <MainButton
              className={`btn btn-primary-dark ps-lg-5 pe-lg-5 ps-3 pe-3`}
              text="Buy Now"
              withLogo={false}
              disabled={selectedProductId === null || isBuyButtonDisabled == true}
              onClick={handleClick}
            />
          </div>
        </div>
      </section>

      <Snackbar
        message={snackbarState.message}
        type={snackbarState.type}
        show={snackbarState.show}
        onClose={hideSnackbar}
        duration={9000}
      />
    </>
  );
};

export default Basic;
